import type {sessionType} from "@/assets/ts/types/session";

const state = (): sessionType => ({
    session_id: "",
    items: [],
    set: {
        filename: "",
        filename_layer: "",
        positions: []
    },
    persons: [],
    engravings: [],
    last_modified: "",
    expires: "",
    itemIdx: 0,
    viewMode: "item",
    configureAll: true,
});

const getters = {
    get(state: sessionType): sessionType {
        return {
            session_id: state.session_id,
            items: state.items,
            set: state.set,
            persons: state.persons,
            engravings: state.engravings,
            last_modified: state.last_modified,
            expires: state.expires,
            itemIdx: state.itemIdx,
            viewMode: state.viewMode,
            configureAll: state.configureAll,
        };
    },
    getNumberOfItems(state: sessionType): number {
        return state.items?.length || 0;
    },
    getItemIdx(state: sessionType): number {
        return state.itemIdx;
    },
    getViewMode(state: sessionType): string {
        return state.viewMode;
    },
    getConfigureAll(state: sessionType): boolean {
        return state.configureAll;
    },
    getMainMetal(state: sessionType): string {
        const item: any = state.items?.[state.itemIdx];
        if (!item || !item.variants) return "white";
        return item.image.main_metal
    },
    getVariant: (state: any) => (itemIdx: number, variantIdx: string): any[] => {
        const item: any = state.items?.[itemIdx];
        if (!item || !item.variants) return [];

        const variants = []

        for (const posIdx in item.variants) {
            const parts = item.variants[posIdx].idx.split('.');
            let checkVariantIdx = item.variants[posIdx].idx;
            if (parts.length == 3 && !isNaN(parts[1]) && variantIdx.indexOf(".*.") > -1) {
                parts[1] = "*"
                checkVariantIdx = parts.join('.')
            }

            if (checkVariantIdx === variantIdx) {
                variants.push(item.variants[posIdx]);
            }
        }
        return variants;
    },
};

const actions = {};

const mutations = {
    setFull(state: sessionType, session_data: sessionType): void {
        state.session_id = session_data.session_id;
        state.last_modified = session_data.last_modified;
        state.expires = session_data.expires;
        state.items = session_data.items;
        state.set = session_data.set;
        state.persons = session_data.persons;
        state.engravings = session_data.engravings;
        if (typeof session_data.itemIdx !== "undefined") {
            state.itemIdx = session_data.itemIdx;
        }
        if (typeof session_data.viewMode !== "undefined") {
            state.viewMode = session_data.viewMode;
        }
    },
    setItemIdx(state: sessionType, itemIdx: number): void {
        state.itemIdx = itemIdx;
    },
    setViewMode(state: sessionType, viewMode: string): void {
        state.viewMode = viewMode;
    },
    setConfigureAll(state: sessionType, configureAll: boolean): void {
        state.configureAll = configureAll;
    },
    setVariantValues(state: any, { itemIdx, variantIdx, values }: { itemIdx: number, variantIdx: string, values: any[] }): void {
        const item = state.items[itemIdx];
        if (!item) return;
        const variant = item.variants.find((v: any) => v.idx === variantIdx);
        if (variant) {
            variant.values = values;
        }
    },
    removeVariant(state: any, { itemIdx, variantIdx }: { itemIdx: number, variantIdx: string }): void {
        const item = state.items[itemIdx];
        if (!item || !item.variants) return;
        item.variants = item.variants.filter((v: any) => v.idx !== variantIdx);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
